import Filter from "@/api/query/filters/filter";

/**
 * Оператор "IN"
 */
export default class In extends Filter {
    static #OPERATOR = "in";

    getOperator() {
        return "in"; //In.#OPERATOR;
    }
}
